export function   userMustNotInsertTid(mapping, mappingCube) {

  if (mapping === null) {
    return true;
  }
  if (mappingCube === null) {
    return true;
  }
  const cubeTidAttrs = mappingCube.Attributes.filter(attr => attr.IsTid) || [];
  if (cubeTidAttrs.length === 0) {
    return true;
  }
  const cubeTidAttrCode = cubeTidAttrs[0].Code;
  const mappingTidAttrs = (mapping.Components || []).filter(comp =>
    comp.CubeComponentCode ===  cubeTidAttrCode) || [];

  return mappingTidAttrs.length > 0;
}
